import { addDays, setISOWeek, setYear } from 'date-fns';

// Helper function to calculate start and end dates from year and week number
export const getWeekDates = (year, weekNumber) => {
  try {
    // Convert inputs to numbers to ensure proper handling
    const numYear = parseInt(year, 10);
    const numWeek = parseInt(weekNumber, 10);

    if (isNaN(numYear) || isNaN(numWeek)) {
      console.error('Invalid year or week number:', { year, weekNumber });
      // Return current date as fallback
      const now = new Date();
      return {
        startDate: now,
        endDate: now
      };
    }

    // Create a date for January 1st of the given year
    let date = new Date(numYear, 0, 1);

    // Set the ISO week
    date = setISOWeek(date, numWeek);

    // Ensure we're in the correct year (setISOWeek might change the year)
    date = setYear(date, numYear);

    // Monday is the first day of the week
    const dayOfWeek = date.getDay() || 7; // Convert Sunday (0) to 7
    const diff = dayOfWeek - 1; // Difference from Monday

    // Calculate start date (Monday)
    const startDate = addDays(date, -diff);

    // Calculate end date (Sunday)
    const endDate = addDays(startDate, 6);

    return { startDate, endDate };
  } catch (error) {
    console.error('Error calculating week dates:', error);
    // Return current date as fallback
    const now = new Date();
    return {
      startDate: now,
      endDate: now
    };
  }
};